import { css } from 'emotion';

export const surveyProgress = css`
  width: 320px;

  @media (max-width: 800px) {
    width: 160px;
  }
`;
